<template>
  <div class="col-85 filtre-resultats">
    <template v-if="itemList && itemList.results && itemList.results.length">
      <pagination-item
        class="-my-2"
        :items="itemList"
        :page="page"
        @changePage="
          $emit('update:page', $event)
          $emit('changePage')
        "
      ></pagination-item>
      <template v-for="item in itemList.results">
        <component
          :is="components[item.doc_type]"
          :key="item.id"
          :item="item"
        ></component>
      </template>

      <pagination-item
        :items="itemList"
        :page="page"
        @changePage="
          $emit('update:page', $event)
          $emit('changePage')
        "
      ></pagination-item>
    </template>
    <div v-else class="empty-results">
      Aucun résultat disponible pour cette recherche.
    </div>
  </div>
</template>

<script>
import ProductsListingRow from '@/components/ProductsListingRow'
import SubstancesListingRow from '@/components/SubstancesListingRow'
import NewsListingRow from '@/components/NewsListingRow'
import ArticlesListingRow from '@/components/ArticlesListingRow'
import PaginationItem from '@/components/PaginationItem'

export default {
  name: 'GeneralListing',
  components: {
    ProductsListingRow,
    SubstancesListingRow,
    NewsListingRow,
    PaginationItem,
    ArticlesListingRow
  },

  data () {
    return {
      components: {
        product: 'ProductsListingRow',
        activesubstance: 'SubstancesListingRow',
        new: 'NewsListingRow',
        flatpage: 'ArticlesListingRow'
      }
    }
  },

  props: {
    itemList: Object,
    page: Number
  }
}
</script>
